import { PLATFORM_EXTENSIONS } from '@constants';

export const getUrl = (envName, path) => {
  // XXX: Currently SRE gives us the hostname that handle the API
  // the http(s) part is missing. So we have to do this on our side ...
  const base = process.env[envName];

  if (base === undefined || base === '') {
    return null;
  }

  if (base.match(/^https?:/)) {
    return `${base}${path}`;
  }

  return `https://${base}${path}`;
};

export const getAncestorsUrl = (categoryId, platform) => {
  if (!categoryId || !platform) return null;
  const path = `/api/v4/categories/${categoryId}?platform=${platform.toUpperCase()}`;
  const url = getUrl('INFRA_KONG_API_ADDR', path);

  return url;
};

const getQueryStringParams = params =>
  Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');

export const getCampaignUrl = (baseUrl, platform, market, targetParams) => {
  if (!baseUrl || !platform || !market) return null;

  const upperCasePlatform = platform.toUpperCase();
  const platformExtension = PLATFORM_EXTENSIONS[upperCasePlatform];

  const platformBaseUrl = platformExtension
    ? baseUrl.replace('.com', platformExtension)
    : baseUrl;
  const basePath = `https://${platformBaseUrl}/api/v1/campaigns`;

  const targetQueryStringParams = getQueryStringParams(targetParams);
  const urlQueryStringParams = targetQueryStringParams
    ? `?${targetQueryStringParams}`
    : '';
  const slug = 'top_banner';

  return `${basePath}/${upperCasePlatform}/${market}/${slug}${urlQueryStringParams}`;
};

const getAncestorsParams = (ancestors = []) => {
  const level0 = ancestors[0];
  const level1 = ancestors[1];

  return {
    ...(level0 && level0.id && { level_0_id: level0.id }),
    ...(level0 && level0.name && { level_0_name: level0.name }),
    ...(level1 && level1.id && { level_1_id: level1.id }),
    ...(level1 && level1.name && { level_1_name: level1.name }),
  };
};

export const getCampaignUrlTargetParams = (
  pageName,
  ancestors,
  userId,
  isNewUser,
) => {
  let targetParams = {};

  if (pageName) targetParams.page_name = pageName;
  if (userId) targetParams.user_id = userId;
  if (isNewUser !== undefined) targetParams.new_user = isNewUser;
  if (ancestors) {
    const ancestorsParams = getAncestorsParams(ancestors);
    targetParams = { ...targetParams, ...ancestorsParams };
  }

  return targetParams;
};
